import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import TempWorkFlow from "./TempWorkFlow";

// import actions
import { DocumentTemplateActions } from "../../actions";

// import services
import {
  addTemplateComponentService,
  updateTemplateOrder,
  deleteTemplateComponentService,
  updateTemplateComponentService,
  updateTemplateSectionLabelService,
} from "../../actions/DocumentTemplateActions/templateService";

import Document from "../Document";

const { getClauses, reOrderTemplateSectionList } = DocumentTemplateActions;

class DocumentTemplate extends Component {
  state = {
    mode: "TEMPLATE",
  };

  componentDidMount = () => {
    const { clauseIDs } = this.props;
    if (clauseIDs) {
      this.props.getClauses(clauseIDs);
    }
    document.title = "Templates";
  };

  render() {
    const { mode } = this.state;
    const { reOrderSectionListAction, showWorkFlowScreen } = this.props;
    return (
      <Fragment>
        <Document
          {...this.props}
          mode={mode}
          addNewSectionService={addTemplateComponentService}
          deleteSectionService={deleteTemplateComponentService}
          updateSectionService={updateTemplateComponentService}
          updateSectionLabelService={updateTemplateSectionLabelService}
          reOrderSectionListAction={reOrderSectionListAction}
          reOrderSectionListService={updateTemplateOrder}
          toggleAddWorkflowScreen={this._toggleAddWorkflowScreen}
        />
        {showWorkFlowScreen && (
          <div className="document-clause-options-pane">
            <TempWorkFlow />
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    workflow: { showWorkFlowScreen },
  } = state.TemplateStore;

  const { components } = state.DocumentStore;

  const clauseIDs = Object.keys(components)
    .map(componentId =>
      components[componentId].content
        ? components[componentId].content.clauseID
        : null,
    )
    .filter(clause => Boolean(clause));

  return { clauseIDs, showWorkFlowScreen };
};

const mapDispatchToProps = {
  getClauses,
  reOrderSectionListAction: reOrderTemplateSectionList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentTemplate);



// WEBPACK FOOTER //
// ./src/components/Template/DocumentTemplate.js